import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import '../../voyage-popup/src/voyage-popup';
import '../../voy-timeinput/src/voy-timeinput';
import '../../voy-terminal-input/src/voy-terminal-input';

import { VoyTimeinput } from '../../voy-timeinput/src/voy-timeinput';
import { TerminalInfo } from '../../../src/models/types/terminals-model.types';
import { SimplifiedPortCall } from '../../../src/models/types/voyage-schedules-model.types';

@customElement("vessel-edit-schedule-add")
export class VesselEditScheduleAdd extends LitElement {

    @property({attribute: false}) departurePort: SimplifiedPortCall | null = null;
    @property({attribute: false}) arrivalTerminalId: string = "";
    @property({attribute: false}) arrivalEta: number = -1;
    @property({attribute: false}) arrivalEtd: number = -1;
    @property({attribute: false}) valid: boolean = false;
    @property({type: Boolean}) shown: boolean = false;
    @property({type: Boolean}) resetControl: boolean = false;

    static get styles() {
        return [
            css`
                .container {
                    display: grid;
                    grid-template-columns: 1fr auto 1fr;
                    place-content: center;
                    width: min-content;
                    border: 1px solid var(--neutrals-grey-07);
                    background: var(--neutrals-grey-10);
                    font-family: 'MaerskText';
                    font-size: 14px;
                }

                .port-call {
                    display: grid;
                    grid-template-rows: auto auto auto auto;
                    place-content: center;
                    grid-gap: 30px;
                    margin: 0 auto;
                    padding: 15px;
                }

                .border-line {
                    border: 1px solid var(--neutrals-grey-07);
                }

                .footer {
                    color: var(--neutrals-grey-05);
                    margin-top: -25px;
                    min-height: 38px;
                }
        `];
    }

    render() {
        const departureTerminalCode = this.departurePort ? this.departurePort.terminalCode : "";

        return html`

            <voyage-popup no-close-button ?shown=${this.shown} header-text=${`Add Port Inducement`} @close=${this._onClose} @accept=${this._onAccept} accept-button-text=${"Next"} no-overflow ?disable-accept-button=${!this.valid}>
                <div class="container" data-test="add-port-popup">
                    <div class="port-call" data-test="from">
                        <voy-terminal-input .terminalId=${departureTerminalCode} .label=${"From"} .readonly=${true}></voy-terminal-input>
                        <voy-timeinput custom-label="ETA" id="from-eta" terminal-id=${departureTerminalCode} ?readonly=${true}></voy-timeinput>
                        <voy-timeinput custom-label="ETD" id="from-etd" terminal-id=${departureTerminalCode} ?readonly=${true}></voy-timeinput>
                        <div class="footer"></div>
                    </div>
                    <div class="border-line"></div>
                    <div class="port-call departure">
                        <voy-terminal-input id="resultingTerminal" .terminalId=${this.arrivalTerminalId} .label=${"To"} @terminal-selected=${(evt:CustomEvent<TerminalInfo>) => { this.arrivalTerminalId = evt.detail.locationId }}></voy-terminal-input>
                        <voy-timeinput custom-label="ETA" id="to-eta" terminal-id=${this.arrivalTerminalId} @input=${(evt:InputEvent) => { this.arrivalEta = (<VoyTimeinput>evt.target).value }}></voy-timeinput>
                        <voy-timeinput custom-label="ETD" id="to-etd" terminal-id=${this.arrivalTerminalId} @input=${(evt:InputEvent) => { this.arrivalEtd = (<VoyTimeinput>evt.target).value }}></voy-timeinput>
                        <div class="footer">If you don’t know the exact ETD, you can add one now and update it later.</div>
                    </div>
                    
                </div>
            </voyage-popup>
       `;
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has("departurePort")) {
            if (this.departurePort)
            {
                (<VoyTimeinput>this.shadowRoot!.getElementById("from-eta")).value = new Date(this.departurePort.arrivalAt).getTime();
                (<VoyTimeinput>this.shadowRoot!.getElementById("from-etd")).value = new Date(this.departurePort.departureAt).getTime();
            }
            else
            {
                (<VoyTimeinput>this.shadowRoot!.getElementById("from-eta")).value = -1;
                (<VoyTimeinput>this.shadowRoot!.getElementById("from-etd")).value = -1;
            }
        }

        if (!this.arrivalTerminalId || this.arrivalEta === -1 || this.arrivalEtd === -1 || (this.arrivalEtd < this.arrivalEta))
        {
            this.valid = false;
        }
        else
        {
            this.valid = true;
        }

        super.updated(changedProperties);
    }

    private _onClose(){
        this.dispatchEvent(new Event('cancel'));
    }

    private async _onAccept(){
        this.dispatchEvent(new CustomEvent<SimplifiedPortCall>('accept', { detail: {
            gsisId: null,
            localId: null,
            terminalCode: this.arrivalTerminalId,
            arrivalAt: new Date(this.arrivalEta).toISOString(),
            departureAt: new Date(this.arrivalEtd).toISOString(),
            omitted: false,
            actuals: { pilotStationArrivalAt: null, pilotOnAt: null, arrivalAt: null, departureAt: null, pilotOffAt: null }
        }}));
    }    
}
